"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailSchema = void 0;
var constants_1 = require("@hobt/constants");
var utils_1 = require("@hobt/utils");
var constants_2 = require("../../constants");
var currentDate = utils_1.getCurrentDate();
exports.detailSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'claimTypeCode',
        'contestedFlag',
        'evictionFlag',
        'legalActionStartedDate',
        'interestAdjustmentDate',
        'legalSystemTypeCode',
        'mobileHomeOnLeasedLandFlag',
        'mortgageTypeCode',
        'receivedDefaultInterestRatePercent',
        'receivedLastCompleteInstallmentPaidDueDate',
        'receivedOutstandingPrincipalBalanceAmount',
        'receivedTaxAccountBalanceAmount',
        'taxAccountBalanceTypeCode',
    ],
    properties: {
        additionalSecuritiesHeldByBorrowerTypeCode: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_2.AdditionalSecuritiesHeldByBorrower), [null, NaN]),
            errorMessage: 'should be a valid AdditionalSecuritiesHeldByBorrower Enum value',
        },
        britishColumbiaYukonSaleClosingDate: {
            type: 'string',
            format: 'date',
            strictlyPastDate: true,
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        calendarDaysDeferredCount: {
            type: 'number',
            minimum: 0,
            maximum: 120,
            errorMessage: 'should be numeric between 0 and 120',
        },
        claimFilingExtensionObtainedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be true or false',
        },
        claimTypeCode: {
            type: 'string',
            enum: Object.values(constants_2.ClaimTypeCode),
            errorMessage: 'should be a valid TypeOfClaim Enum value',
        },
        contestedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be true or false',
        },
        evictionFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be true or false',
        },
        informationSentToNationalRecoveriesCentreDate: {
            type: 'string',
            format: 'date',
            strictlyPastDate: true,
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        interestAdjustmentDate: {
            type: 'string',
            format: 'date',
            strictlyPastDate: true,
            errorMessage: 'should be formatted as yyyy-mm-dd',
            formatExclusiveMaximum: {
                $data: '1/receivedLastCompleteInstallmentPaidDueDate',
                customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_INTEREST_ADJUSTMENT_DATE),
            },
        },
        judgmentBankruptcyInformationReceivedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        legalActionCompletedDate: {
            type: ['string', 'null'],
            format: 'date',
            strictlyPastDate: true,
            errorMessage: 'should be formatted as yyyy-mm-dd',
            formatMinimum: {
                $data: '1/legalActionStartedDate',
                customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_LEGAL_ACTION_COMPLETED),
            },
        },
        legalActionStartedDate: {
            type: 'string',
            format: 'date',
            strictlyPastDate: true,
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        legalActionTypeCode: {
            type: 'number',
            enum: Object.values(constants_2.LegalActionType),
            errorMessage: 'should be a valid LegalActionType Enum value',
        },
        legalSystemTypeCode: {
            type: 'number',
            enum: Object.values(constants_2.LegalSystemType),
            errorMessage: 'should be a valid LegalSystemType Enum value',
        },
        mainClaimDueDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        mobileHomeOnLeasedLandFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be true or false',
        },
        mortgageTypeCode: {
            type: 'number',
            enum: Object.values(constants_2.MortgageType),
            errorMessage: 'should be a valid MortgageType Enum value',
        },
        offerAcceptedDate: {
            type: 'string',
            format: 'date',
            strictlyPastDate: true,
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        otherLegalActionTypeDescription: {
            type: 'string',
            minLength: 0,
            maxLength: 60,
            errorMessage: 'should have maximum length of 60 characters',
        },
        propertyOccupancyStatusCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_2.PropertyOccupancyStatus), [null]),
            errorMessage: 'should be a valid PropertyOccupancyStatus Enum value',
        },
        propertySoldByTypeCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_2.PropertySoldBy), [null]),
            errorMessage: 'should be a valid PropertySoldBy Enum value',
        },
        propertyTransferredByTypeCode: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_2.PropertyTransferredBy), [null]),
            errorMessage: 'should be a valid PropertyTransferredBy Enum value',
        },
        propertyVacancyDate: {
            type: 'string',
            format: 'date',
            strictlyPastDate: true,
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        propertyVacatedByTypeCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_2.PropertyVacatedBy), [null]),
            errorMessage: 'should be a valid PropertyVacatedBy Enum value',
        },
        receivedLenderNotificationDate: {
            type: 'string',
            format: 'date',
            formatMinimum: {
                $data: '1/receivedLastCompleteInstallmentPaidDueDate',
                customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_RECEIVED_LENDER_NOTIFICATION),
            },
            formatMaximum: {
                const: currentDate,
                customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'receivedLenderNotificationDate'),
            },
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        receivedDefaultInterestRatePercent: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            decimal: [7, 4],
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision or null',
        },
        receivedDeficiencySaleClosingDate: {
            type: ['string', 'null'],
            format: 'date',
            strictlyPastDate: true,
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        receivedDeficiencySaleCommissionAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        receivedDeficiencySalePriceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        receivedLastCompleteInstallmentPaidDueDate: {
            type: 'string',
            format: 'date',
            strictlyPastDate: true,
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        receivedOutstandingPrincipalBalanceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        receivedTaxAccountBalanceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        representativeToObtainKey: {
            type: 'object',
            required: [],
            properties: {
                fullName: {
                    type: 'string',
                    minLength: 0,
                    maxLength: 35,
                    errorMessage: 'should have maximum length of 35 characters',
                },
                phoneNumber: {
                    type: 'string',
                    minLength: 0,
                    maxLength: 10,
                    errorMessage: 'should have length of 10 characters',
                },
            },
            if: {
                properties: {
                    phoneNumber: {
                        const: '',
                    },
                },
            },
            else: {
                properties: {
                    phoneNumber: {
                        type: 'string',
                        minLength: 10,
                        maxLength: 10,
                    },
                },
            },
        },
        taxAccountBalanceTypeCode: {
            type: 'number',
            enum: Object.values(constants_2.TaxAccountBalanceType),
            errorMessage: 'should be a valid TaxAccountBalanceType Enum value',
        },
        warrantyTypeCode: {
            type: 'string',
            enum: Object.values(constants_2.WarrantyType),
            errorMessage: 'should be a valid WarrantyType Enum value',
        },
    },
};
